import Repository from "@shared/services/api/abstracts/Repository";
import { UrlRouteMap } from "@shared/services/api/types";
import { AxiosRequestConfig } from "axios";

export default class PublicUserSMSRepository extends Repository<string> {
  public readonly repositoryName = "PublicUserSMSRepository";

  public readonly endpoint = "api/user/phones/sms/";

  public get urlMap(): UrlRouteMap {
    return {
      ...this.defaultUrlMap,
      deliverTickets: "{transaction_id}/deliver-tickets",
    };
  }

  public async deliverTickets(
    transaction_id?: string,
    config: AxiosRequestConfig = {},
    data?: {
      uuid1?: string;
      uuid2?: string;
      phone_number?: string | null;
    }
  ): Promise<void> {
    await this.request(this.buildUrl("deliverTickets", { transaction_id }), {
      method: "post",
      data,
      ...config,
    });
  }
}
